export const deprecationPlanQueryKeys = {
  all: ['deprecationPlans'] as const,
  lists: () => [...deprecationPlanQueryKeys.all, 'list'] as const,
  list: (companyId: string, budgetingScenarioId?: number | null) =>
    [...deprecationPlanQueryKeys.lists(), companyId, budgetingScenarioId ?? null] as const,
  details: () => [...deprecationPlanQueryKeys.all, 'detail'] as const,
  detail: (companyId: string, deprecationPlanId: number) =>
    [...deprecationPlanQueryKeys.details(), companyId, deprecationPlanId] as const
}
